import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { DataTable } from "../../../common/table/data-table/data-table-component";
import UserSearchComponent from "../../../common/user-search/user-search.component";
import Icon from "../../../icon";

export class DetailsInfo extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.resetDefault=this.resetDefault.bind(this);
    this.state={
      show:false,
      clearData:false,
      selected:[],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
      selectedTwo:[]
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {    
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };

  resetDefault() {   
    this.setState({clearData:true});
  }

  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show,selected,clearData }=this.state;
    return(
      <>

        <Icon
            name="circle-info-reg"
            size="18px"
            customClassName="icon-nav"            
            containerClass="info-container"
            onClick={this.handleShow.bind(this)}
        />
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-dialog-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <div className="inventory-detail-info-container data-table">
              <div className="detail-info-wrapper">
                 <table className="detail-main-table">
                   <tbody>
                      <tr>
                          <td>ACCOUNT NUMBER</td>
                          <td>BES0512312323</td>
                        </tr>
                        <tr>
                          <td>ACCOUNT TYPE</td>
                          <td>Master</td>
                        </tr>
                        <tr>
                          <td>CONTRACT ID</td>
                          <td>Contract Verizon Data 123</td>
                        </tr>
                        <tr>
                          <td>ACCOUNT NUMBER</td>
                          <td>BES0512312323</td>
                        </tr>
                   </tbody>
                 </table>
                 <h1>LOCATION</h1>
                 <table className="detail-main-table">
                    <tbody>
                      <tr>
                        <td>BILLING ADDRESS</td>
                        <td>100246 Gen Roxas & Gen Aguinaldo Avenues - Gateway Tower Quezon CircuitInventoryReport
                            National Capital Region Philippines
                        </td>
                      </tr>
                      <tr>
                        <td>REMIT ADDRESS</td>
                        <td>100246 Gen Roxas & Gen Aguinaldo Avenues - Gateway Tower Quezon CircuitInventoryReport
                            National Capital Region Philippines
                        </td>
                      </tr>
                    </tbody>
                 </table>
                 <h1>COST ALLOCATION</h1>
                 {this.props.costAllocationData.map((item,id)=>
                    <DataTable key={id} id={id} item={item} header={item.HeaderItem} showSearchBox={false} data={item.dataItem} isDataLoaded={true} customClassName="table-container" />
                )}
              </div>
              <div className="vertical-separator"></div>
              <div className="detail-info-wrapper circuit-info-wrapper">
                  <div className="linked-circuit-container">
                    <h1>LINKED CIRCUITS</h1>
                    <span>56 Total Circuit</span>
                  </div>
                  <div className="billing-acc-search-container">
                    <UserSearchComponent />
                  </div>
                  {this.props.circuitData.map((item,id)=>
                    <DataTable key={id} id={id} item={item} header={item.HeaderItem} showSearchBox={false} data={item.dataItem} isDataLoaded={true} customClassName="table-container" />
                )}               
              </div>
           </div>
        </Modal.Body>        
      </Modal>

      </>
    );
  }
}
